import { createSelector } from '@reduxjs/toolkit'
import { AppState } from 'store/appState'

export const getAIAgentAbuseReport = createSelector(
  (state: AppState) => state.ai.popup,
  popup => popup.isAbuseReport,
)
